import Flickity from 'flickity';
import lottie from "lottie-web";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
gsap.registerPlugin(CustomEase, ScrollTrigger, MotionPathPlugin, MotionPathHelper);

window.addEventListener('load', function () {

	if( document.body.classList.contains('page-template-page-venue')) {

		var squirrelEl = document.getElementById('sitting-squirrel');
    var squirrelAnimation = lottie.loadAnimation({
      wrapper: squirrelEl,
      animType: 'svg',
      loop: true,
      autoplay:true,
      path: 'https://res.cloudinary.com/deif6jglp/raw/upload/v1657211281/Il%20Mercato/sitting_squirrel_i4dhny.json'
    });

    squirrelAnimation.play();

		// FROG ANIMATION

		gsap.to("#frog-animation__frog", {
      ease: "power1.inOut",
      duration:1.15,
      scrollTrigger: {
        trigger: "#frog-branch",
        start:"top 85%",
      },
      motionPath:{
        path: "#frog-animation__path",
        align: "#frog-animation__path",
        autoRotate: false,
        alignOrigin: [0.5, 0.5],
        start:0,
        end: 1
      }
    });

		// VENUE SLIDERS

		const venueSliders = document.querySelectorAll('.venue-spaces__slider');
		venueSliders.forEach((slider) => {

			var flkty = new Flickity( slider.querySelector('.venue-spaces__images'), {
			  pageDots: false,
			  prevNextButtons: false,
			  wrapAround: true
			});

			slider.querySelector('.prev').addEventListener('click', () => {
				flkty.previous();
			});

			slider.querySelector('.next').addEventListener('click', () => {
				flkty.next();
			});

			flkty.on( 'change', function( index ) {
				slider.querySelector('.active-slide').innerHTML = index + 1;
			});

		});

	}

}, false);